import React, { useRef, useState } from 'react';
import { useEffect } from 'react';
import LogoBlack from 'assets/images/logo-dark.svg';
import AuthLanguageSwitcher from '../../../../ui-component/AuthLanguageSwitcher';
import { useLanguage } from '../../../../contexts/LanguageContext';

const NavBarLogin = () => {
	useEffect(() => {
		document.title = 'Projectmix';
	}, []);
	const { locale } = useLanguage();
	return (
		<nav id="mainNav" className="navbar-expand navbar-light topbar m-0 static-top d-flex justify-content-between">
			<div className="nav-search"
					 style={locale === 'ae' ? { paddingRight: '7rem' } : { paddingLeft: '7rem' }}
			>
				<img src={LogoBlack} alt="logo" className="img-fluid" width={180} />
			</div>

			<div className="nav-actions">
				<AuthLanguageSwitcher />
			</div>
		</nav>
	);
};

export default NavBarLogin;
